import React, { useRef } from "react";
import { IconSearch, IconX, IconLoader2 } from "@tabler/icons-react";
import { Search } from "lucide-react";

interface SearchInputProps {
  value: string;
  onChange: (value: string) => void;
  onClear: () => void;
  onFocus: () => void;
  onBlur: () => void;
  onKeyDown: (e: React.KeyboardEvent) => void;
  isLoading: boolean;
  placeholder?: string;
}

export function SearchInput({
  value,
  onChange,
  onClear,
  onFocus,
  onBlur,
  onKeyDown,
  isLoading,
  placeholder = "Discover...",
}: SearchInputProps) {
  const inputRef = useRef<HTMLInputElement>(null);

  return (
    <div className="relative max-w-md w-full">
      <div className="relative flex items-center w-full">
        <div className="absolute left-3 text-medium">
          {isLoading ? (
            <IconLoader2 size={18} className="animate-spin" />
          ) : (
            <IconSearch size={16} className="text-black" />
          )}
        </div>
        <input
          ref={inputRef}
          type="text"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          onFocus={onFocus}
          onBlur={onBlur}
          onKeyDown={onKeyDown}
          placeholder={placeholder}
          className="flex w-full rounded-full bg-light hover:bg-light h-[40px] px-4 pl-9 pr-9 py-3 text-base shadow-none transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-neutral-400 hover:placeholder:text-neutral-500/80 focus:bg-light focus-visible:outline-black focus-visible:outline focus-visible:outline-2 disabled:cursor-not-allowed disabled:opacity-50"
        />
        <div className="absolute right-3 flex items-center space-x-1">
          {value && (
            <button
              type="button"
              onClick={onClear}
              className="p-1 text-medium hover:text-foreground"
            >
              <IconX size={16} />
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
